import { useEffect } from 'react';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';

export const usePrefersReducedAnimation = (): void => {
  const isAnimationOn = usePrefersReducedMotion();

  /**
   * update the repeatCount attribute value
   * to stop/start the animation
   */
  useEffect(() => {
    const setAnimationAttribute = (value: string): void => {
      const animateCircle = document.getElementsByClassName('animateCircle') || [];

      for (let i = 0; i < animateCircle.length; i++) {
        const element = animateCircle[i] as HTMLElement;
        element.setAttribute('repeatCount', value);
      }
    };

    if (isAnimationOn) setAnimationAttribute('1');
    else setAnimationAttribute('indefinite');
  });
};
